import { jsx as _jsx } from "react/jsx-runtime";
import SwapVertIcon from '@material-ui/icons/SwapVert';
export const SwapVertReverse = (props) => (_jsx(SwapVertIcon, Object.assign({}, props, { style: { transform: 'scaleX(-1)' } })));
export default SwapVertReverse;
//# sourceMappingURL=SwapVertReverse.js.map